const apiUrl = process.env.REACT_APP_BACKEND_HOST;

const tryHackMeLabsProvider = {
  getOne: async (params) => {
    const { cohortId = params.id, courseId } = params;
    const url = `${apiUrl}/cohorts/${encodeURIComponent(
      cohortId,
    )}/courses/${encodeURIComponent(courseId)}/tryhackme-labs-progress`;
    return { url };
  },
};

export default tryHackMeLabsProvider;
